import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";

type Args = {
  organizationId: number;
  mediaId: number;
};

/**
 * Set a logo as the main logo for an organization.
 */
export function useSetMainLogo() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ organizationId, mediaId }: Args) => {
      return await apiRequest(
        `/organization/${organizationId}/logo/${mediaId}/set-main/`,
        "POST"
      );
    },
    onSuccess: (_data, variables) => {
      // Invalidate logos query to refetch updated data
      queryClient.invalidateQueries({
        queryKey: ["organization", variables.organizationId, "logos"],
      });
    },
  });
}

